import React, { useMemo } from 'react';

import { Button, Collapse } from '@mui/material';
import { useToggle } from 'react-use';

import classes from './ComplianceScoreSection.module.scss';
import { ModalInputBox } from '../../../../shared/components/modals';
import { StarText } from '../../../../shared/components/ui-components';
import { SuggestionScenariosInfo } from '../../../interfaces/suggestionScenariosInfo';
import { getFormattedDate } from '../../../../shared/utils/dateUtils';
import { dateFormat, localDataFormat } from '../../../../shared/constants/apiDateFormat';
import { getRoundedNumber } from '../../../../shared/utils/mathUtils';
import { getSortedArrByDate } from '../../../../shared/utils/sortingAndGroupingUtil';

type ComplianceScoreSectionProps = {
  scanDetails: SuggestionScenariosInfo['scanDetails'];
};

export const ComplianceScoreSection = ({ scanDetails }: ComplianceScoreSectionProps) => {
  const [isShowScores, toggleShowScores] = useToggle(false);

  const sortedScores = useMemo(
    () => getSortedArrByDate(scanDetails.scores, 'date', dateFormat, false),
    [scanDetails.scores],
  );

  return (
    <ModalInputBox
      title={
        <div className={classes.title}>
          <span>Average Compliance Score:</span>
          <StarText size="medium">{getRoundedNumber(scanDetails.scoreTotal, 1)}</StarText>
        </div>
      }
      adornment={
        !!sortedScores.length && (
          <Button
            variant="text"
            size="small"
            onClick={toggleShowScores}
            className={classes.button}
          >
            {isShowScores ? 'Hide All Scores' : 'Show All Scores'}
          </Button>
        )
      }
    >
      <Collapse in={isShowScores} mountOnEnter unmountOnExit>
        <div className={classes.scoreBox}>
          {sortedScores.map((score) => (
            <div key={score.date} className={classes.scoreRow}>
              <span className={classes.label}>
                {getFormattedDate(score.date, localDataFormat, dateFormat)}
              </span>
              <span className={classes.value}>{getRoundedNumber(score.score, 2)}</span>
            </div>
          ))}
        </div>
      </Collapse>
    </ModalInputBox>
  );
};
